import { render, staticRenderFns } from "./itemchart.vue?vue&type=template&id=eda25a4e&scoped=true&"
import script from "./itemchart.vue?vue&type=script&lang=js&"
export * from "./itemchart.vue?vue&type=script&lang=js&"
import style0 from "./itemchart.vue?vue&type=style&index=0&id=eda25a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda25a4e",
  null
  
)

export default component.exports